import { useLanguage } from "@/i18n";
import { Reveal } from "@/components/Reveal";

export default function Manifesto() {
  const { t } = useLanguage();

  return (
    <section className="relative bg-ebony text-bone py-24 md:py-32 overflow-hidden" data-testid="manifesto-section">
      <div className="absolute inset-0 pattern-kitenge" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-ochre mb-4">{t.manifesto.overline}</p>
          <h2 className="font-serif font-light text-4xl sm:text-5xl lg:text-6xl tracking-tighter mb-20 md:mb-28" data-testid="manifesto-title">
            {t.manifesto.title}
          </h2>
        </Reveal>
        <div className="space-y-16 md:space-y-24">
          {t.manifesto.chapters.map((ch, i) => (
            <Reveal key={ch.num} delay={0.05 * i}>
              <div className="grid md:grid-cols-12 gap-6 md:gap-10 items-start border-t border-bone/10 pt-10 md:pt-14">
                <span className="md:col-span-3 font-serif text-6xl md:text-8xl font-light text-ochre/90 leading-none">{ch.num}</span>
                <h3 className="md:col-span-4 font-serif text-2xl md:text-3xl italic tracking-tight text-bone">{ch.title}</h3>
                <p className="md:col-span-5 text-sm md:text-base font-light leading-relaxed text-bone/70">{ch.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
